export const uk = {
    'are-you-sure-to-apply-many-campaigns': 'Изменятся {count} кампаний. Применить рекомендацию?',
    'are-you-sure-to-apply-many-groups': 'Изменятся {count} групп. Применить рекомендацию?',
    'are-you-sure-to-apply-one-campaigns': 'Изменится {count} кампания. Применить рекомендацию?',
    'are-you-sure-to-apply-one-groups': 'Изменится {count} группа. Применить рекомендацию?',
    'are-you-sure-to-apply-some-campaigns': 'Изменятся {count} кампании. Применить рекомендацию?',
    'are-you-sure-to-apply-some-groups': 'Изменятся {count} группы. Применить рекомендацию?',
    'autotargeting-context-result': 'Включен автотаргетинг для группы «{name}»',
    'autotargeting-context-result-error': 'Не удалось включить автотаргетинг для группы  «{name}»',
    'autotargeting-context-result-error-with-refresh':
        'Не удалось включить автотаргетинг для группы  «{name}». Обновите страницу',
    'autotargeting-grid-result': 'Включен автотаргетинг для группы «{name}»',
    'autotargeting-grid-result-error': 'Не удалось включить автотаргетинг для группы «{name}»',
    'autotargeting-grid-result-error-with-refresh':
        'Не удалось включить автотаргетинг для группы «{name}». Обновите страницу',
    banner: 'объявление №{id}',
    'banner-title': {
        one: '{count} рекомендация для улучшения работы ваших объявлений',
        some: '{count} рекомендации для улучшения работы ваших объявлений',
        many: '{count} рекомендаций для улучшения работы ваших объявлений',
        none: '{count} рекомендаций для улучшения работы ваших объявлений'
    },
    campaign: 'кампания №{id}',
    'campaign-budget-context-result': 'Повышено ограничение бюджета для кампании «{name}»',
    'campaign-budget-context-result-error': 'Не удалось повысить ограничение бюджета для кампании «{name}»',
    'campaign-budget-context-result-error-with-refresh':
        'Не удалось повысить ограничение бюджета для кампании «{name}». Обновите страницу',
    'campaign-budget-grid-result': 'Повышено ограничение бюджета для кампании «{name}»',
    'campaign-budget-grid-result-error': 'Не удалось повысить ограничение бюджета для кампании «{name}»',
    'campaign-budget-grid-result-error-with-refresh':
        'Не удалось повысить ограничение бюджета для кампании «{name}». Обновите страницу',
    'campaign-title': {
        one: '{count} рекомендация для улучшения работы вашей кампании',
        some: '{count} рекомендации для улучшения работы вашей кампании',
        many: '{count} рекомендаций для улучшения работы вашей кампании',
        none: '{count} рекомендаций для улучшения работы вашей кампании'
    },
    'error-autotargeting': 'Не удалось включить автотаргетинг',
    'error-autotargeting-with-refresh': 'Не удалось включить автотаргетинг. Обновите страницу',
    'error-campaign-budget': 'Не удалось повысить ограничение бюджета',
    'error-campaign-budget-with-refresh': 'Не удалось повысить ограничение бюджета. Обновите страницу',
    'error-fobidden-pages': 'Не удалось разрешить показы на качественных площадках',
    'error-fobidden-pages-with-refresh': 'Не удалось разрешить показы на качественных площадках. Обновите страницу',
    'fobidden-pages-context-result': 'Разрешены показы на качественной площадке «{name}»',
    'fobidden-pages-context-result-error': 'Не удалось разрешить показы на качественной площадке «{name}»',
    'fobidden-pages-context-result-error-with-refresh':
        'Не удалось разрешить показы на качественной площадке «{name}». Обновите страницу',
    'fobidden-pages-grid-result': 'Разрешены показы на качественных площадках для кампании «{name}»',
    'fobidden-pages-grid-result-error': 'Не удалось разрешить показы на качественных площадках для кампании «{name}»',
    'fobidden-pages-grid-result-error-with-refresh':
        'Не удалось разрешить показы на качественных площадках для кампании «{name}». Обновите страницу',
    'general-context-result': 'Рекомендация применена',
    'general-context-result-error': 'Рекомендация не применена. Произошла ошибка',
    'general-grid-result': 'Рекомендация применена',
    'general-grid-result-error': 'Во время применения рекомендации произошла ошибка',
    group: 'группа №{id}',
    'group-title': {
        one: '{count} рекомендация для улучшения работы вашей группы',
        some: '{count} рекомендации для улучшения работы вашей группы',
        many: '{count} рекомендаций для улучшения работы вашей группы',
        none: '{count} рекомендаций для улучшения работы вашей группы'
    },
    'many-items-full-autotargeting-result': 'Включен автотаргетинг для {count} групп',
    'many-items-full-campaign-budget-result': 'Повышено ограничение бюджета для {count} кампаний',
    'many-items-full-fobidden-pages-result': 'Разрешены показы на качественных площадках в {count} кампаниях',
    'many-items-full-general-result': 'Рекомендация применена для {count} элементов',
    'many-items-partial-autotargeting-result': 'Включен автотаргетинг для {count} из {total} групп',
    'many-items-partial-campaign-budget-result': 'Повышено ограничение бюджета для {count} из {total} кампаний',
    'many-items-partial-fobidden-pages-result':
        'Разрешены показы на качественных площадках в {count} из {total} кампаний',
    'many-items-partial-general-result': 'Рекомендация применена для {count} элементов из {total}',
    'one-item-full-autotargeting-result': 'Включен автотаргетинг для {count} группы',
    'one-item-full-campaign-budget-result': 'Повышено ограничение бюджета для {count} кампании',
    'one-item-full-fobidden-pages-result': 'Разрешены показы на качественных площадках в {count} кампании',
    'one-item-full-general-result': 'Рекомендация применена для {count} элемента',
    'one-item-partial-autotargeting-result': 'Включен автотаргетинг для {count} из {total} группы',
    'one-item-partial-campaign-budget-result': 'Повышено ограничение бюджета для {count} из {total} кампании',
    'one-item-partial-fobidden-pages-result':
        'Разрешены показы на качественных площадках в {count} из {total} кампании',
    'one-item-partial-general-result': 'Рекомендация применена для {count} элемента из {total}',
    'some-items-full-autotargeting-result': 'Включен автотаргетинг для {count} групп',
    'some-items-full-campaign-budget-result': 'Повышено ограничение бюджета для {count} кампаний',
    'some-items-full-fobidden-pages-result': 'Разрешены показы на качественных площадках в {count} кампаниях',
    'some-items-full-general-result': 'Рекомендация применена для {count} элементов',
    'some-items-partial-autotargeting-result': 'Включен автотаргетинг для {count} из {total} групп',
    'some-items-partial-campaign-budget-result': 'Повышено ограничение бюджета для {count} из {total} кампаний',
    'some-items-partial-fobidden-pages-result':
        'Разрешены показы на качественных площадках в {count} из {total} кампаний',
    'some-items-partial-general-result': 'Рекомендация применена для {count} элементов из {total}',
    title: {
        one: '{count} рекомендация',
        some: '{count} рекомендации',
        many: '{count} рекомендаций',
        none: '{count} рекомендаций'
    }
};
